/* eslint-disable import/order */
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskServiceModalNewRoute } from '@jira/router-routes__servicedesk-services-routes/src/servicedeskServiceModalNewRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ServiceCreateModalWithoutProjectContext, {
	LazyServiceCreateModalWithProjectContext,
} from './ui/service-create-modal-without-project-context/index.tsx';

export const servicedeskServiceModalNewRouteEntry: Route = createEntry(
	servicedeskServiceModalNewRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceCreateModalWithoutProjectContext,
		layout: serviceProjectLayout,
		resources: [...getServiceDeskNavigationResources(), ...getServicedeskPageContextResources()],
		forPaint: [LazyAtlassianNavigation, LazyServiceCreateModalWithProjectContext],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
